import type { User } from "@privy-io/react-auth"
import { resolveEvmWalletAddress } from "../connected-addresses"

export function getGlobalWalletAddress(user: User | null | undefined) {
  return user?.linkedAccounts
    .find((account) => account.type === "cross_app")
    ?.embeddedWallets[0]?.address.toLowerCase()
}

/** Select only the connected signer belonging to the Profile identity. */
export function selectProfileEvmWallet<T extends { address: string }>(options: {
  user: User | null
  wallets: T[]
  getCrossAppWallet?: (address: string) => T
}): T | undefined {
  const address = resolveEvmWalletAddress({
    user: options.user,
    globalWalletAddress: getGlobalWalletAddress(options.user),
    connectedWalletAddress: options.wallets[0]?.address,
  })
  if (!address) return undefined
  const wallet = options.wallets.find(
    (wallet) => wallet.address.toLowerCase() === address.toLowerCase(),
  )
  if (wallet) return wallet
  const crossAppAddress = options.user?.linkedAccounts.find(
    (account) => account.type === "cross_app",
  )?.embeddedWallets[0]?.address
  if (crossAppAddress?.toLowerCase() === address.toLowerCase())
    return options.getCrossAppWallet?.(crossAppAddress)
  return undefined
}
